import { BackendResponse } from "../BackendResponse";
import { NextApiParams, withNextApi } from "../nextApiHelpers";

export interface RemoveKnowledgeFromCandidateResponse extends BackendResponse {}
export interface RemoveKnowledgeFromCandidateParameters extends NextApiParams {
  knowledgeId: number;
}

export const removeKnowledgeFromCandidate = withNextApi<
  RemoveKnowledgeFromCandidateResponse,
  RemoveKnowledgeFromCandidateParameters
>("/cvp/CvpRemoveKnowledgeFromCandidate");
